// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"abb7e7a1","452":"65fc7b53","487":"5afaa6bf","744":"29a01d1a"}[chunkId] + ".chunk.js";
};